<template>
  <div class="inspector-sku-list">
    <div class="inspector-sku-list-header inspector-list-sticky-bar">
      <div class="sku-list-dropdown-wrapper">
        <span v-if="mobileStyle"
              class="mobile-close-line"
              @click="showHideMobileSkuList" />
        <span class="list-title">{{ $t('SKU LIST') }}</span>
        <el-dropdown class="inspector-sku-list-dropdown"
                     trigger="click"
                     @command="changeFilter">
          <span class="el-dropdown-link ddStyle pointer-cursor">
            {{ normalizeString(selectedFilter) }} <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown"
                            class="inspector-sku-list-dropdown-menu">
            <el-dropdown-item v-for="(item, index) in activeSkuListTabs"
                              :key="index"
                              :command="item.name">
              {{ normalizeString(item.name) }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="inspector-sku-list-main">
      <el-collapse v-model="activeCollapse">
        <el-collapse-item v-show="outOfStockSkuList.length > 0"
                          class="oos"
                          :title="$t('Out Of Stock')"
                          name="oos">
          <SkuListItem v-for="sku in outOfStockSkuList"
                       :key="sku.id"
                       :sku="sku"
                       legend-name="missing"
                       :legend-facing-count="sku.extra_infos.missing_count"
                       border-color="#ff4444" />
        </el-collapse-item>
        <el-collapse-item v-show="inStockSkuList.length > 0"
                          class="in-stock"
                          :title="$t('In Stock')"
                          name="inStock">
          <SkuListItem v-for="sku in inStockSkuList"
                       :key="sku.id"
                       :sku="sku"
                       border-color="none" />
        </el-collapse-item>
        <el-collapse-item v-show="missingSkuList.length > 0 && selectedFilter === 'planogram'"
                          class="missing"
                          :title="$t('Missing')"
                          name="missing">
          <SkuListItem v-for="sku in missingSkuList"
                       :key="sku.id"
                       :sku="sku"
                       border-color="#f9cb49"
                       :legend-facing-count="sku.extra_infos.missing_count"
                       legend-name="missing" />
        </el-collapse-item>
        <el-collapse-item v-show="misplacedSkuList.length > 0 && selectedFilter === 'planogram'"
                          class="misplaced"
                          :title="$t('Misplaced')"
                          name="misplaced">
          <SkuListItem v-for="sku in misplacedSkuList"
                       :key="sku.id"
                       :sku="sku"
                       border-color="#6efff1"
                       :legend-facing-count="sku.extra_infos.misplaced_count"
                       legend-name="misplaced" />
        </el-collapse-item>
        <el-collapse-item v-show="excessSkuList.length > 0 && selectedFilter === 'planogram'"
                          class="excess"
                          :title="$t('Excess')"
                          name="excess">
          <SkuListItem v-for="sku in excessSkuList"
                       :key="sku.id"
                       :sku="sku"
                       border-color="#76ff5f"
                       :legend-facing-count="sku.extra_infos.excess_count"
                       legend-name="excess" />
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import {
  isEmpty, uniqBy, minBy
} from 'lodash';
import { mapState } from 'vuex';
import mobileScreenControl from '@/helpers/mixins/mobileScreenControl';
import SkuListItem from './SkuListItem';
import InspectorBus from '../InspectorBus';

export default {
  name: 'InspectorSkuList',
  components: { SkuListItem },
  mixins: [mobileScreenControl],
  props: {
    reportData: {
      type: Object,
      required: true
    },
    filteredSkuList: {
      type: Array,
      default() {
        return [];
      }
    },
    mobileStyle: {
      type: Boolean,
      default: false
    },
    realogramItemList: {
      type: Array,
      default() {
        return [];
      }
    },
    planogramItemList: {
      type: Array,
      default() {
        return [];
      }
    },
    outOfStockList: {
      type: Object,
      default() {
        return {};
      }
    },
    // realogram legends
    missingList: {
      type: Object,
      default() {
        return {};
      }
    },
    misplacedList: {
      type: Object,
      default() {
        return {};
      }
    },
    excessList: {
      type: Object,
      default() {
        return {};
      }
    },
    inStockList: {
      type: Object,
      default() {
        return [];
      }
    },
    isPlanogramActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeCollapse: ['missing', 'misplaced', 'excess', 'oos', 'inStock'],
      selectedFilter: 'must_have',
      isMobileSkuListVisible: true
    };
  },
  computed: {
    ...mapState(['Project']),
    reportDataSkuList() {
      if (this.reportData.report && this.reportData.report.sku_list) {
        return this.reportData.report.sku_list;
      }

      return [];
    },
    excessSkuList() {
      return this.getSkuList(this.excessList);
    },
    missingSkuList() {
      return this.getSkuList(this.missingList);
    },
    misplacedSkuList() {
      return this.getSkuList(this.misplacedList);
    },
    outOfStockSkuList() {
      return this.getOutofStockSkuList();
    },
    inStockSkuList() {
      return this.getSkuList(this.inStockList);
    },
    isGetActiveTabsHaveList() {
      return !isEmpty(this.Project.active.data.settings.sku_list_tabs);
    },
    activeSkuListTabs() {
      const listArray = ['excessList', 'missingList', 'misplacedList', 'inStockList'];
      const availabileTabs = [];
      const skuListTabs = this.Project.active.data.settings.sku_list_tabs;

      if (skuListTabs) {
        skuListTabs.forEach((tab) => {
          const inStockListCheck = listArray.some((list) => {
            if (this.getSkuList(this[list], tab.name).length) return true;

            return false;
          });
          const outOfStockListCheck = this.getOutofStockSkuList(tab).length > 0;

          if (inStockListCheck || outOfStockListCheck) availabileTabs.push(tab);
        });
      }

      return availabileTabs;
    }
  },
  mounted() {
    if (this.isGetActiveTabsHaveList) {
      this.selectedFilter = minBy(this.activeSkuListTabs, 'position').name;
    }

    this.checkLegends(this.missingList, 'missing');
    this.checkLegends(this.misplacedList, 'misplaced');
    this.checkLegends(this.excessList, 'excess');
  },
  methods: {
    changeFilter(selected) {
      this.selectedFilter = selected;
    },
    checkLegends(list, legendType) {
      const legendIndex = InspectorBus.skuLegends.findIndex(legend => legend.id === legendType);

      InspectorBus.skuLegends[legendIndex].show = !!(list.planogram.length !== 0 || list.realogram.length !== 0);
    },
    showHideMobileSkuList() {
      this.isMobileSkuListVisible = !this.isMobileSkuListVisible;
      this.$emit('closeSkuListDrawer');
    },
    getSkuList(list, filter) {
      const planogram = list.planogram.filter(item => item.extra_infos[filter || this.selectedFilter]);
      const realogram = list.realogram.filter(item => item.extra_infos[filter || this.selectedFilter]);

      return uniqBy([...planogram, ...realogram], 'id');
    },
    getOutofStockSkuList(filter) {
      const planogram = this.outOfStockList.planogram.filter(item => !item.extra_infos.available);
      const realogram = this.outOfStockList.realogram.filter(item => !item.extra_infos.available);
      const flattenList = uniqBy([...planogram, ...realogram], 'id');

      return flattenList.filter(i => i.extra_infos[filter || this.selectedFilter] === false);
    }
  }
};
</script>

<style lang="scss">
.inspector-sku-list {
  width: 100%;
  height: calc(100vh - 240px);
  overflow-y: scroll;
  border-left: 1px solid #c7c7c7;

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13.5px 10px;
    background-color: #fff;
    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.25);

    .sku-list-dropdown-wrapper {
      position: relative;

      .mobile-close-line {
        display: none;

        @include breakpoint(lg-max) {
          position: absolute;
          bottom: 25px;
          left: 38%;
          display: block;
          width: 80px;
          height: 4px;
          background-color: #d9d9d9;
        }
      }

      @include breakpoint(lg-max) {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
    }

    .inspector-sku-list-dropdown {
      .el-dropdown-link {
        font-size: 14px;
        font-weight: 600;
        line-height: 19.07px;
        color: $darkSkyBlue;

        i {
          font-size: 18px;
          font-weight: bold;
          color: $darkSkyBlue;
        }
      }
    }

    .list-title {
      margin-right: 8px;
      font-size: 14px;
      font-weight: 700;
      color: $cavernous;
    }

    .hide-btn {
      font-size: 23px;
      cursor: pointer;

      &:hover {
        color: $darkSkyBlue;
      }
    }
  }

  &-main {
    padding: 0 10px;

    .el-collapse-item {
      &__header {
        font-size: 13px;
        font-weight: 700;
        line-height: 17.7px;
        border-bottom: none;

        i {
          font-size: 18px;
          font-weight: 600;
        }
      }

      &__wrap {
        border-bottom: none;
      }

      &.oos {
        .el-collapse-item__header {
          color: #f44;
        }
      }

      &.missing {
        .el-collapse-item__header {
          color: #f9cb49;
        }
      }

      &.misplaced {
        .el-collapse-item__header {
          color: #6dede1;
        }
      }

      &.excess {
        .el-collapse-item__header {
          color: #76ff57;
        }
      }
    }
  }

  .el-collapse {
    border: none;
  }

  .inspector-list-sticky-bar {
    position: sticky;
    top: 0;
    z-index: 1;
    justify-content: space-between;
    width: auto !important;
  }
}

.inspector-sku-list-dropdown-menu {
  li {
    font-size: 14px !important;
    line-height: 37.7px !important;
  }
}
</style>
